<template>
    <div class="part-member-num"> 
        <div class="droplayer relative">
            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" >
                        {{ defaultLanguage.indexOf('ko') != -1 ? item.regUserName : item.regUserNameEn != null ? item.regUserNameEn : item.regUserName }} 
                        <span class="num">{{checkMember(categoryMemberList.length)}}</span>
                    </v-btn>
                </template>
                <div class="dropdown-list">
                    <div class="top" v-html="$i18nUtil.trans('search.000.people','총 {cnt} 명', {cnt: categoryMemberListSize})"></div>
                    <div class="scroll">
                        <div class="members_box">
                            {{memberList()}} 
                        </div>
                    </div>
                </div>
            </v-menu>
        </div>
    </div>

    <!-- <dl class="member-list noicon" v-if="regUserInfo.length != 0  && categoryMemberList.length != 0 ">
        <dt><button type="button" class="ico-txt_user" @mouseover="getCategoryUserList()" >
            {{ regUserInfo[0].userName }} <b>{{checkMember(categoryMemberList.length)}}</b></button></dt>
        <dd class="layer-cnt_ty1 scroll" @mouseleave="$event.target.parentElement.childNodes[0].classList.remove('active')">
            <div class="layer-tit">총 {{categoryMemberListSize}}명</div>
            <div class="scroll_inner" style="height: 70px">
               <span v-for="(user,idx) in categoryMemberList" :key="'user_'+idx">
                   {{user.userName}}
               </span>
            </div>
        </dd>
    </dl> -->
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import axios from "axios";
import Vue from "vue";
export default {
    props:["item","userId"],
    data(){
        return{
            regUserInfo:[],
            categoryMemberList:[],
            myInfo:[],
            categoryMemberListSize:-1,

            defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko'
        }
    },
    mounted(){
        this.getCategoryUserList();
    },
    methods:{
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION" ]),  
        getCategoryUserList() {   
            if(this.categoryMemberListSize == 0 ){

            }else if(this.categoryMemberListSize == -1){  
                    
                let obj = this;
                let reqData = {};
                reqData.params ={
                    categoryMid: this.item.categoryMid
                }
                reqData.req = obj.req;
                reqData.url = "/api/copaper/cooperation/getCfrcCategoryUserList";
                reqData.method = "post";
                obj
                    .COWORK_REST_SIMPLE_ACTION(reqData)
                    .then(res => {   
                        this.categoryMemberList = res.result.categoryUserList; 
                        this.categoryMemberListSize = res.result.categoryUserList.length;

                        let regUserId = this.item.regUserId;     
                        const result2 = this.categoryMemberList.filter(function(user){ 
                            return user.userId == regUserId;
                        });
                        this.regUserInfo = result2;

                        let myUserId = this.userId;
                        const result = this.categoryMemberList.filter(function(user){ 
                            return user.userId == myUserId;
                        });
                        
                        this.myInfo = result;  
 
                    }) 
                    .catch(function(err) {
                        console.log(err);
                    });  
            }else{
                   /*  event.target.parentElement.classList.add('active'); */
            }
        }, 
        checkMember(memberNumber){
            return memberNumber > 999 
                    ? '999+' 
                    : memberNumber == 1
                        ? ''
                        : (memberNumber);
        },
        memberList(){
            let obj = this;
            let userString = '';  
            this.categoryMemberList.forEach(function(user){
                userString += (obj.defaultLanguage.indexOf('ko') != -1 ? user.userName : user.userNameEn != null ? user.userNameEn : user.userName) +", ";
            })
              
            userString = userString.trim(); 
            userString = userString.substring(0,userString.length-1); 
            return userString;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/cooperation/manage/components/CooperationCategoryMember.vue